import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex w-full flex-col items-center py-16 px-8" }
const _hoisted_2 = { class: "mx-auto max-w-[833px] w-full" }

import { computed, inject, ref } from 'vue';
import Steps from '../components/navigation/Steps.vue';
import { StepType, ScheduleType, AppConfigType } from '../types';
import Subject from '../components/new-schedule/Subject.vue';
import Schedule from '../components/new-schedule/Schedule.vue';
import ScheduleSettings from '../components/new-schedule/ScheduleSettings.vue';
import Summary from '../components/new-schedule/Summary.vue';
import useSetPageTitle from '../composables/useSetPageTitle';
import { useGettext } from 'vue3-gettext';
import { useTokensStore } from '../stores/useTokensStore';
import router from '../router';

// Translations

export default /*@__PURE__*/_defineComponent({
  __name: 'AddSchedule',
  setup(__props) {

const { $gettext } = useGettext();

// Get usage limit
const { isTokenLimitReached } = useTokensStore();

// Set page title
useSetPageTitle($gettext('Add schedule'));

// Get plugin config
const config: AppConfigType = inject('pluginConfig');

// Check if it's the first schedule
const isFirstSchedule = config.settings.has_plugin ? false : true;

// Current index and component to be displayed
const activeIndex = ref(0);
const stepComponentMap = {
    0: Subject,
    1: Schedule,
    2: ScheduleSettings,
    3: Summary,
};

// Step options
const stepsOptions: StepType[] = [
    {
        label: $gettext('Subject'),
        callback: () => {
            activeIndex.value = 0;
        },
    },
    {
        label: $gettext('Date & time'),
        callback: () => {
            activeIndex.value = 1;
        },
    },
    {
        label: $gettext('Settings'),
        callback: () => {
            activeIndex.value = 2;
        },
    },
    {
        label: $gettext('Articles'),
    },
];

// Get current step component
const stepComponent = computed(() => stepComponentMap[activeIndex.value]);

// Store schedule settings
const schedule = ref<ScheduleType>({
    id: Math.floor(Math.random() * 1000).toString(),
    topic: '',
    amount: '',
    days: [],
    time: '',
    time_zone: '',
    author: '',
    lang: '',
    advSchedule: null,
    articles_keywords: Array(7).fill([]),
    activity_date_enabled: false,
    activity_date: null,
});

// Check if schedule can be added
if (isTokenLimitReached.value) {
    // Redirect to main page
    router.push('/');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Steps, {
        steps: stepsOptions,
        "active-index": activeIndex.value
      }, null, 8, ["active-index"])
    ]),
    (_openBlock(), _createBlock(_resolveDynamicComponent(stepComponent.value), {
      schedule: schedule.value,
      "is-first-schedule": _unref(isFirstSchedule),
      class: "entry-animation",
      onPreviousStep: _cache[0] || (_cache[0] = ($event: any) => (activeIndex.value--)),
      onNextStep: _cache[1] || (_cache[1] = ($event: any) => (activeIndex.value++)),
      onUpdateSchedule: _cache[2] || (_cache[2] = (newSchedule) => schedule.value = newSchedule)
    }, null, 40, ["schedule", "is-first-schedule"]))
  ]))
}
}

})